type FacebookError = {
    name: 'facebook-auth';
    type: 'not_authorized' | 'unknown';
    subtype?: never;
};

export type GoogleErrorType =
    | 'popup_closed_by_user'
    | 'access_denied'
    | 'immediate_failed'
    | 'idpiframe_initialization_failed';

type GoogleCustomErrorType = 'private-mode' | 'missing-token';

type GoogleError = {
    name: 'google-auth';
    type: GoogleErrorType | GoogleCustomErrorType;
    subtype?: string;
};

export const googleOneTapErrorTypes = [
    'auto_cancel',
    'user_cancel',
    'tap_outside',
    'issuing_failed',
    'browser_not_supported',
    'invalid_client',
    'missing_client_id',
    'opt_out_or_no_session',
    'secure_http_required',
    'suppressed_by_user',
    'unregistered_origin',
    'unknown_reason'
] as const;

type GoogleOneTapCustomErrorType = 'missing-credential';

type GoogleOneTapError = {
    name: 'google-onetap-auth';
    type: typeof googleOneTapErrorTypes[number] | GoogleOneTapCustomErrorType;
    subtype?: string;
};

type SupportedErrors = FacebookError | GoogleError | GoogleOneTapError;

export const formatNewRelicErrorData = ({
    name,
    type,
    subtype
}: SupportedErrors) => {
    if (name === 'facebook-auth') {
        return [name, { failure: true, type }];
    }

    if (name === 'google-onetap-auth') {
        return [
            name,
            {
                failure: true,
                type,
                subtype
            }
        ];
    }

    return [
        name,
        {
            failure: true,
            type,
            subtype
        }
    ];
};
